import ReactGA from "react-ga";
import { injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { Log } from "src/libs/log";
import { Environment } from "src/libs/environment";

@injectable()
export class GoogleAnalyticsService {
    // We are using the same key for old MEP parts. Do not change
    private static readonly KEY_LOCAL_STORAGE_GA_UID = "GA_UID_SETTED";

    private get gaEnvironmentId() {
        return Environment.string("GOOGLE_ANALYTICS");
    }

    @autoBind
    initGA(testMode = false) {
        Log.info(`GA init for ${this.gaEnvironmentId}`);
        ReactGA.initialize(this.gaEnvironmentId, { testMode });
    }

    @autoBind
    logUserId(userIdentifier: string) {
        ReactGA.set({ userId: userIdentifier });
        localStorage.setItem(
            GoogleAnalyticsService.KEY_LOCAL_STORAGE_GA_UID,
            "true"
        );
        Log.info("GA:userId", userIdentifier);
    }

    @autoBind
    isSettedUID() {
        return (
            localStorage.getItem(
                GoogleAnalyticsService.KEY_LOCAL_STORAGE_GA_UID
            ) === "true"
        );
    }

    @autoBind
    logPageView(url?: string) {
        // We are taking an URL as a parameter or by default the location of the current page
        const urlView =
            url || window.location.href.split(window.location.origin)[1];
        ReactGA.set({ page: urlView });
        ReactGA.pageview(urlView);
        Log.info("GA:", urlView);
    }

    @autoBind
    logEvent(gaEvent: ReactGA.EventArgs) {
        ReactGA.event(gaEvent);
    }
}
